import { css } from "@emotion/react";

import { colors } from "../../styles";

export const propertyListingTiles = css`
  min-height: 400px;
`;

export const loader = css`
  font-size: 1.7em;
  position: relative;
  top: 180px;
  color: ${colors.gray};
`;

export const propertylistingTilesContainer = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
`;
